// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\naudio[data-v-ca1a11ba] {\n  pointer-events: none;\n  position: fixed;\n  bottom: 0;\n  right: 0;\n}\n", ""]);
// Exports
module.exports = exports;
